import { render, staticRenderFns } from "./ProductGeneralSelection.vue?vue&type=template&id=abcc55a6&scoped=true"
import script from "./ProductGeneralSelection.vue?vue&type=script&lang=js"
export * from "./ProductGeneralSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcc55a6",
  null
  
)

export default component.exports